import DiamondIcon from "../../../assets/diamond.svg";
import './index.css';

export default function Divider({text}: { text: string}) {
    return <div className='divider-container flex font-[400] text-[14px] text-[#333] justify-center items-center mt-[60px] md:mt-[120px] gap-2 opacity-[0.6] border border-[##D0D5DD99] rounded-[48px] p-3'>
        <img src={DiamondIcon} alt='diamond'/>
        <p>{text}</p>
    </div>
}
